import { createStore } from "vuex";

const localStorageKey = 'DJsdfg-2352LLDSF-dfg***//|sfdsgYHGASFhds';

export default createStore({
    state: {
        isAuthenticated: false,
        token: '',
        username: '',
        rol: '',
        code: '',
        codeVendor: 0,
        nameVendor: ''
    },
    getters: {

    },
    mutations: {
        setIsAuthenticated(state, value) {
            state.isAuthenticated = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },
        setUsername(state, value){
            state.username = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },
        setToken(state, value){
            state.token = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },
        setRol(state, value){
            state.rol = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },
        setCode(state, value){
            state.code = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },
        setCodeVendor(state, value){
            state.codeVendor = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },
        setNameVendor(state, value){
            state.nameVendor = value;
            localStorage.setItem(localStorageKey, JSON.stringify(state));
        },
        // Agregar una mutación para inicializar el estado desde localStorage al cargar la página
        initializeStateFromLocalStorage(state) {
            const storedState = localStorage.getItem(localStorageKey);
            if (storedState) {
                Object.assign(state, JSON.parse(storedState));
            }
        }
    },
    actions: {
        initializeStateFromLocalStorage({ commit }) {
            commit('initializeStateFromLocalStorage');
        }
    }
})